export const Props = () => ({
  //--------------------------------------------------------------------------
  //                                      Объект поста
  //--------------------------------------------------------------------------
  post: {
    type: Object,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                                   Это из колонки альфа?
  //--------------------------------------------------------------------------
  isAlpha: {
    type: Boolean,
    required: true
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});